import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IconButton from '@material-ui/core/IconButton'
import DeleteIcon from '@material-ui/icons/Delete'
import Tooltip from '@material-ui/core/Tooltip'
import Avatar from '@material-ui/core/Avatar'
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';

import StyleSheet from 'styles'
import Checkbox from 'components/styled/Checkbox'

export class UserListItem extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    selected: PropTypes.bool,
    onSelected: PropTypes.func,
    onDeleted: PropTypes.func,
    showAvatar: PropTypes.bool
  }

  static defaultProps = {
    selected: false,
    showAvatar: true
  }

  handleToggleSelect = () => {
    if(this.props.onSelected) {
      this.props.onSelected()
    }
  }

  handleDelete = () => {
    if(this.props.onDeleted) {
      this.props.onDeleted()
    }
  }

  get isSelectable() {
    return !!this.props.onSelected
  }

  get isDeletable() {
    return !!this.props.onDeleted
  }

  buildAvatarFor = (label, code) =>
    <Tooltip title={label}>
      <Avatar className={styles.avatar}>{code}</Avatar>
    </Tooltip>

  avatarFor = ({accessLevel, issuerStatus, investorStatus}) => {
    if(accessLevel === 'admin')
      return this.buildAvatarFor('Admin user', 'ADM')
    if(issuerStatus === 'approved' && investorStatus === 'approved')
      return this.buildAvatarFor("Issuer & Investor", 'BTH')
    if(issuerStatus === 'approved')
      return this.buildAvatarFor("Issuer","ISU")
    if(investorStatus === 'approved')
      return this.buildAvatarFor("Investor","INV")
    else
      return this.buildAvatarFor("Member","MEM")
  }

  render() {
    const {
      name, email,
      investorStatus, issuerStatus,
      investorAccountName, issuerAccountName,
      accessLevel
    } = this.props.user

    return(
      <ListItem classes={{root: styles.listItemRoot}} className={styles.userListItem} onClick={this.handleToggleSelect}>
        { this.isSelectable &&
          <Checkbox small className={styles.checkbox} checked={!!this.props.selected} onClick={this.handleToggleSelect} theme='dark'/>
        }
        {this.props.showAvatar && this.avatarFor({investorStatus, issuerStatus, accessLevel})}
        <ListItemText primary={
          <p>
            <span className={styles.listItemPrimary}>{name}</span><br/>
            <span className={styles.listItemSecondary}>{email}</span><br/>
            <span className={styles.listItemSecondary}>{[investorAccountName, issuerAccountName].filter(x => x).join(' | ')}</span>
          </p>
        }/>
        <ListItemSecondaryAction className={styles.ListItemSecondaryAction}>
          { this.isDeletable &&
            <IconButton aria-label="delete" onClick={ this.handleDelete }>
              <DeleteIcon />
            </IconButton>
          }
        </ListItemSecondaryAction>
      </ListItem>
    )
  }
}

const styles = StyleSheet({
  avatar: {
    width: 30,
    height: 30,
    fontSize: 12,
    fontWeight: 'bold',
    color: 'black',
    background: '#7c8481'
  },
  listItemPrimary: {
    fontSize: '13px',
    fontWeight: 'bold',
    color: 'white !important',
  },
  listItemSecondary: {
    fontSize: '13px',
    fontWeight: 'normal',
    color: 'white !important',
  },
  userListItem: {
    cursor: 'pointer',
    padding: '0 0px',
    wordBreak: 'break-all',
    minHeight: 70
  },
  checkbox: {
  },
  listItemRoot: {
    color: 'white !important',
    alignItems: 'baseline'
  }
})